import StaffSection from "./StaffSection";
import CustomersView from "./CustomersView";

const SectionPages = {
  StaffSection,
  CustomersView,
};

export default SectionPages;
